import StencilHTMLElement from "./stencil-element";

class OffcanvasCloseSubMenu extends StencilHTMLElement {
  name = "OffcanvasCloseSubMenu";

  constructor() {
    super();
    this.toggleSubmenu = this.toggleSubmenu.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.toggleSubmenu);
  }

  // Can I use toggle instead of add/remove?
  toggleSubmenu(e) {
    const togglePanelSelector = e.currentTarget.getAttribute('data-toggle-panel');
    const panel = document.querySelector(togglePanelSelector);
  
    if (!panel) return;
  
    const isHidden = panel.classList.contains('d-none');
  
    if (isHidden) {
      panel.classList.remove('d-none', 'slide-out');
      panel.classList.add('slide-in');
    } else {
      panel.classList.remove('slide-in');
      panel.classList.add('slide-out');
      setTimeout(() => {
        panel.classList.add('d-none');
      }, 300);
    }
  }
}

export default OffcanvasCloseSubMenu;
